export default "__VITE_ASSET__CwkbEjje__"